const testimonials = [
  {
    name: "SSgt. Marcus D.",
    location: "Davis-Monthan AFB, Tucson",
    rating: 5,
    text: "Got PCS orders to Osan with 22 days to report and my wife&apos;s passport had expired the year before. I was panicking because we have two kids and I had no idea how to handle dependent passports on this timeline. Fast Passport Center walked us through everything — told us exactly which acceptance facility to visit at Tucson main post office for my wife&apos;s renewal and guided us on the kids&apos; application process. All three passports arrived in eight business days. We made it to Korea on time.",
    service: "Family Military Passports",
  },
  {
    name: "Dr. Yolanda R.",
    location: "UA Campus, Tucson",
    rating: 5,
    text: "I am an astronomy professor at UA and my passport expired between two observing runs at our telescope site in Chile. The next run was six weeks away and the standard post office timeline was not going to work. Fast Passport Center handled my renewal through expedited processing and I had my passport back in nine business days. The document review they did caught an issue with my photo that would have caused a delay — they caught it before submission. I have recommended them to every colleague planning international fieldwork.",
    service: "Expedited Renewal",
  },
  {
    name: "Brandon W.",
    location: "Marana, Tucson Metro",
    rating: 5,
    text: "I work as an engineer at Raytheon and received notice of an international travel requirement with two weeks lead time. My passport had expired during the COVID years when I wasn&apos;t traveling for work. I found Fast Passport Center online, started the process Monday morning, shipped my documents Monday afternoon from a FedEx near my Marana home, and had a new passport the following Tuesday — seven business days total. My manager was convinced I wouldn&apos;t make it. I did.",
    service: "Passport Renewal",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function TucsonTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Tucson &amp; Southern Arizona Travelers Say
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from Davis-Monthan military families, University of Arizona researchers, and Raytheon professionals who trusted Fast Passport Center with their expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div key={i} className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col">
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}